/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 08/05/2023.
 */
import { useParams } from 'react-router-dom'
import { AuditFactory } from '../../util/auditFactory'
import { Pagination } from 'antd'
import { useSubjectAudit } from '../../hooks/useSubjectAudit'
import { useLayoutEffect, useRef } from 'react'

type Props = {
  onLoaded?: (value) => void
}
export const SubjectAuditTrial = ({ onLoaded }: Props) => {
  const { projectId, subjectId } = useParams() as { projectId: string; subjectId: string }

  const { data, setPageNumber, pageNumber, limit, isValidating } = useSubjectAudit(projectId, subjectId)
  const { auditEvents, totalCount } = data

  const ref = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    if (data && !isValidating && onLoaded) {
      const k = ref.current ? ref.current.getBoundingClientRect().height : 0

      onLoaded(k)
    }
  }, [data, isValidating, onLoaded])

  const onChangePage = (pageNumber: number) => {
    setPageNumber(pageNumber)
  }

  return (
    <div className="container-fluid" ref={ref}>
      <div className="row">
        <div className="col-12 mb-3 d-flex justify-content-center align-items-center">
          {/*totalCount is undefined until data has been loaded in initial render*/}
          <div className={totalCount ? 'visible' : 'invisible'}>
            <Pagination
              key={pageNumber}
              defaultCurrent={pageNumber}
              defaultPageSize={limit}
              showSizeChanger={false}
              total={totalCount}
              onChange={onChangePage}
            />
          </div>
        </div>
      </div>
      <AuditFactory data={auditEvents}></AuditFactory>
      <div className="row" style={{}}>
        <div className="col-12 d-flex justify-content-center ">
          <Pagination
            key={pageNumber}
            defaultCurrent={pageNumber}
            defaultPageSize={limit}
            showSizeChanger={false}
            total={totalCount}
            onChange={onChangePage}
          />
        </div>
      </div>
    </div>
  )
}
